module.exports = __webpack_public_path__ + "img/2_4.3ea63041.png";